export function createWithOverrides<OverrideKey extends PropertyKey>(
	overrides: Partial<Record<OverrideKey, boolean>>,
) {
	return (key: OverrideKey, val: boolean): boolean => {
		if (Object.prototype.hasOwnProperty.call(overrides, key)) {
			const overrideVal = overrides[key];
			if (typeof overrideVal === 'boolean') {
				return overrideVal;
			}
		}
		return val;
	};
}
